module.exports = {"0":"K","50":"K","100":"1","150":"1","200":"1","250":"1","300":"2","350":"2","400":"2","450":"2","500":"3","550":"3","600":"3","650":"3","700":"4","750":"4","800":"5","850":"5","900":"6","950":"6","1000":"7","1050":"8","1100":"9","1150":"10","1200":"11","1220":"12"}


//////////////////
// WEBPACK FOOTER
// ./assets/data/lexile-grade-level-lookup.json
// module id = 3070
// module chunks = 0